import React, { useEffect, useState } from 'react';

import {
    GetPaperPlanMetadataInput,
    GetPaperPlanMetadataOutput,
    PaperPlanMetadata
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import { UnknownCoralError } from '@amzn/ihm-js-coral-client';
import Column from '@amzn/meridian/column';

import { useParams } from 'react-router-dom';
import { contractConfigurationClient } from 'src/api/client';
import { BreadcrumbWrapper } from 'src/components/Breadcrumb';
import { defaultPlanValues } from 'src/constants/paperPlans';
import { ROUTES } from 'src/constants/routes';
import { AppContext } from 'src/contexts/appContext';
import { useTitle } from 'src/hooks/useTitle';
import { IBreadcrumb } from 'src/types/IBreadcrumb';
import { IPaperPlanDetailParams, IPlanValues } from 'src/types/IPaperPlan';
import { mapPaperPlanMetadataToPlanValues } from 'src/util/PaperPlans/PaperPlanUtils';

import { PlanDetail } from './PlanDetail';

export const PaperPlanDetail = () => {
    const breadcrumbItems: IBreadcrumb[] = [
        { link: ROUTES.PAPER_PLANS.INDEX, title: 'PAPER plans' },
        { link: '', title: 'Plan details' }
    ];

    const { setTopAlertMsg } = React.useContext(AppContext);
    const [planValues, setPlanValues] = useState<IPlanValues>(defaultPlanValues);
    useTitle(`View PAPER plan: ${planValues.paperPlanName}`);

    const params: IPaperPlanDetailParams = useParams();
    const paperPlanId = parseInt(params.paperPlanId);

    useEffect(() => {
        contractConfigurationClient
            .getPaperPlanMetadata(GetPaperPlanMetadataInput.clone({ paperPlanId: paperPlanId }))
            .subscribe(
                (response: GetPaperPlanMetadataOutput) => {
                    if (response.planMetadata && response.planMetadata.length > 0) {
                        const plan: PaperPlanMetadata = response.planMetadata[0];
                        setPlanValues(mapPaperPlanMetadataToPlanValues(plan) as IPlanValues);
                    }
                },
                (error: UnknownCoralError) => {
                    console.error('getPaperPlanMetadata unexpected error', error.receivedException.message);
                    setTopAlertMsg(error.receivedException.message);
                }
            );
    }, []);

    return (
        <Column alignmentHorizontal="center" spacingInset="500 500 600">
            <Column width={950} maxWidth="100%" spacing="500">
                <BreadcrumbWrapper breadcrumbItems={breadcrumbItems} />
                <PlanDetail heading="Plan Details" planValues={planValues} hasEditCancelBtn={true} />
            </Column>
        </Column>
    );
};
